import { forEach } from 'lodash';

import { GoogleMap } from './maps/GoogleMap';

// Initialize all dealersite_maps shortcode maps
const maps = document.querySelectorAll('.dealersite-map');
if (maps.length) {
  forEach(maps, (el) => {
    const options = JSON.parse(el.dataset.options);
    new GoogleMap({
      el: el,
      apiKey: DSP_MAPS_API_KEY || '',
      ...options,
    });
  });
}
